import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import moment from 'moment';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import User from '_class/User';
import DateTime from '_class/DateTime';
import { PRESCHOOL } from "constants/schoolTypes";
import { isUserAdministrator, isUserTeacher } from 'helpers/user';
import { addError } from 'actions';
import { setPageTitle, setPageActions } from 'actions/header';
import { getNotesByReference, resetActiveNote, setActiveNote, removeNote } from 'actions/notes';
import { getForm, getFormInstance, getFormTemplate, updateFormInstance } from 'actions/templates';
import { createMeetingInstanceRelationship, getMeeting, getMeetingInstance, updateMeetingInstance, deleteMeetingInstanceRelationship, deleteMeetingInstanceParticipant, updateMeetingInstanceDate, createMeetingFormInstance, deleteMeetingInstance } from 'actions/meetings';
import swal from 'sweetalert2';
import PostContent from 'components/Presentation/PostContent';
import NoteForm from 'containers/Forms/Note';
import DisplayFormResults from 'containers/FormTemplate/Display/DisplayFormResults';
import FormInstance from 'containers/FormTemplate/Display/FormInstance';
import Modal from 'containers/Modals/Modal';
import UserProgress from 'containers/Progress/User';
import UpdateMeetingInstance from '../Form/UpdateMeetingInstance';
import Message from 'containers/SinglePages/Partials/Message';
import MeetingUsers from 'components/List/MeetingUsers';
import BookMeeting from '../Form/BookMeeting';
import { Button, Block, Icon, Checkbox, Tabs, Tab, getActiveLanguage } from '@haldor/ui';
import { Spinner } from 'UI';
import './Meeting.scss';

var ics = require('ics');

var MeetingInstance = /*#__PURE__*/function (_Component) {
  _inherits(MeetingInstance, _Component);

  var _super = _createSuper(MeetingInstance);

  /* Class setup */
  function MeetingInstance(props) {
    var _this;

    _classCallCheck(this, MeetingInstance);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var user = new User(_this.props.user);

      if (!user.isStudent()) {
        var actions = [];

        _this.props.setPageActions(actions);
      }

      _this.loadInstance();
    });

    _defineProperty(_assertThisInitialized(_this), "onParticipantSelect", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(participant) {
        var found;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                found = _this.state.participants.find(function (part) {
                  return part.id == participant.id;
                });

                if (!(found == null)) {
                  _context.next = 7;
                  break;
                }

                participant.present = true;
                _context.next = 5;
                return _this.setState({
                  participants: [].concat(_toConsumableArray(_this.state.participants), [participant])
                });

              case 5:
                _context.next = 10;
                break;

              case 7:
                participant.present = false;
                _context.next = 10;
                return _this.setState({
                  participants: _toConsumableArray(_this.state.participants.filter(function (t) {
                    return t.id != participant.id;
                  }))
                });

              case 10:
                _this.saveInstance(false);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onRemoveParticipant", function (participant) {
      var _this$props = _this.props,
          meeting = _this$props.meeting,
          meetingInstance = _this$props.meetingInstance;
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('are-you-sure-you-want-to-delete'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('No'),
        confirmButtonText: _this.props.translate('Yes')
      }).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(response) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(response.value != null)) {
                    _context2.next = 4;
                    break;
                  }

                  _context2.next = 3;
                  return _this.props.deleteMeetingInstanceParticipant(meeting.id, meetingInstance.id, participant.id);

                case 3:
                  _this.loadInstance();

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "onDeleteMeetingInstance", function () {
      var _this$props2 = _this.props,
          meeting = _this$props2.meeting,
          meetingInstance = _this$props2.meetingInstance;
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('are-you-sure-you-want-to-delete'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('No'),
        confirmButtonText: _this.props.translate('Yes')
      }).then( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(response) {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!(response.value != null)) {
                    _context3.next = 4;
                    break;
                  }

                  _context3.next = 3;
                  return _this.props.deleteMeetingInstance(meeting.id, meetingInstance.id);

                case 3:
                  _this.props.history.push("/meeting/".concat(meeting.id));

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "saveInstance", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var reload,
          instance,
          _args4 = arguments;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              reload = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : true;

              _this.setState({
                saving: true
              });

              instance = {
                id: _this.props.match.params.instanceId,
                meetingId: _this.props.match.params.id,
                outcome: _this.state.outcome,
                status: 'PUBLISHED',
                date: _this.state.date,
                endDate: _this.state.endDate,
                description: _this.state.description,
                followUp: _this.state.followUp,
                participants: _this.state.participants
              };
              _context4.next = 5;
              return _this.props.updateMeetingInstance(instance);

            case 5:
              if (reload) {
                _this.loadInstance();
              } else {
                _this.setState({
                  saving: false
                });
              }

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    })));

    _defineProperty(_assertThisInitialized(_this), "onFormInstanceClick", function (form) {
      var _this$props3 = _this.props,
          meeting = _this$props3.meeting,
          meetingInstance = _this$props3.meetingInstance;
      var formTemplate = JSON.parse(JSON.stringify(form.form.reference.formTemplate));
      var formTemplateFields = JSON.parse(JSON.stringify(form.form.reference.formTemplate.fields));

      _this.setState({
        formTemplate: formTemplate,
        formTemplateFields: formTemplateFields,
        form: form.form.reference,
        formInstance: form.formInstance
      });

      if (form.participant.userID == _this.props.user.id && meetingInstance.status != 'COMPLETED') {
        _this.toggleAnswerForm();
      } else {
        _this.toggleFormPreview();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleFormPreview", function () {
      _this.setState({
        modalFormInstance: !_this.state.modalFormInstance
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleAnswerForm", function (loadData) {
      _this.setState({
        answerFormModal: !_this.state.answerFormModal
      }, function () {
        if (loadData) {
          _this.loadInstance();
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateMeetingInstance", function (values) {
      return new Promise( /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(resolve) {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  if (values.staff != null) {
                    values.staff.forEach(function (staff) {
                      values.participants.push({
                        userId: staff.userId,
                        userType: staff.userType
                      });
                    });
                  }

                  _this.props.updateMeetingInstance(values).then(function () {
                    _this.toggleEditMeetingInstanceModal();

                    _this.loadInstance();
                  });

                case 2:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x4) {
          return _ref5.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "toggleNoteForm", function () {
      var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var values = arguments.length > 1 ? arguments[1] : undefined;
      return new Promise(function (resolve) {
        if (reload) {
          _this.setState({
            loading: true
          });

          var _this$props$match$par = _this.props.match.params,
              instanceId = _this$props$match$par.instanceId,
              id = _this$props$match$par.id;
          var promises = [_this.props.getMeetingInstance(id, instanceId), _this.props.getNotesByReference(_this.props.match.params.instanceId, "MEETING_INSTANCE")];
          Promise.all(promises).then(function () {
            _this.setState({
              noteForm: !_this.state.noteForm,
              loading: false
            });

            _this.props.resetActiveNote();

            resolve(1);
          });
        } else {
          _this.setState({
            noteForm: !_this.state.noteForm
          });

          _this.props.resetActiveNote();

          resolve(1);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onNoteClick", function (note, isPublic) {
      _this.props.setActiveNote(note);

      _this.setState({
        noteForm: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onNoteRemove", function (note) {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('note-delete-prompt'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('Cancel'),
        confirmButtonText: _this.props.translate('Delete')
      }).then( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(result) {
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (!(result.value != null)) {
                    _context6.next = 4;
                    break;
                  }

                  _context6.next = 3;
                  return _this.props.removeNote(note.id);

                case 3:
                  _this.props.getMeetingInstance(_this.props.match.params.id, _this.props.match.params.instanceId);

                case 4:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x5) {
          return _ref6.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "createTeamsMeeting", function () {
      _this.setState({
        creatingTeamsMeeting: true
      });

      return new Promise(function (resolve) {
        var data = _this.props.meetingInstance;
        data.addTeamsMeeting = true;

        _this.props.updateMeetingInstance(data).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return _this.props.getMeetingInstance(_this.props.match.params.id, _this.props.match.params.instanceId);

                case 2:
                  _this.setState({
                    creatingTeamsMeeting: false
                  });

                  resolve(1);

                case 4:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        })));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "unbookTeamsMeeting", function () {
      _this.setState({
        creatingTeamsMeeting: true
      });

      return new Promise(function (resolve) {
        var data = _this.props.meetingInstance;
        data.addTeamsMeeting = false;
        data.teamsMeeting = null;
        data.teamsMeetingData = null;

        _this.props.updateMeetingInstance(data).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return _this.props.getMeetingInstance(_this.props.match.params.id, _this.props.match.params.instanceId);

                case 2:
                  _this.setState({
                    creatingTeamsMeeting: false
                  });

                  resolve(1);

                case 4:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        })));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleEditMeetingInstanceModal", function () {
      _this.setState({
        editMeetingInstanceModal: !_this.state.editMeetingInstanceModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "generateICS", function () {
      var date = moment.utc(_this.props.meetingInstance.date).local().format('YYYY-M-D-H-m').split("-");
      date = date.map(function (point) {
        return parseInt(point, 10);
      });
      var endDate = moment.utc(_this.props.meetingInstance.endDate).local();
      var duration = moment.duration(endDate.diff(moment.utc(_this.props.meetingInstance.date).local()));
      var hours = Math.floor(duration.asHours());
      var minutes = Math.round(duration.asMinutes() - hours * 60);
      var description = '';

      if (_this.props.meetingInstance.description != null) {
        var meetingInstanceDescription = document.createElement('div');
        meetingInstanceDescription.innerHTML = _this.props.meetingInstance.description;
        description += meetingInstanceDescription.innerText + "\n\n";
      }

      if (_this.props.meeting.description != null) {
        var meetingDescription = document.createElement('div');
        meetingDescription.innerHTML = _this.props.meeting.description;
        description += meetingDescription.innerText;
      }

      if (_this.props.meetingInstance.teamsMeetingData != null && _this.props.meetingInstance.teamsMeetingData.joinWebUrl != null) {
        description += "\n\n------------------\nAnslut till m\xF6tet:\n".concat(_this.props.meetingInstance.teamsMeetingData.joinWebUrl);
      }

      var uid = moment.utc(_this.props.meetingInstance.date).local().toISOString();
      uid += '-M' + _this.props.meeting.id;
      uid += '-I' + _this.props.meetingInstance.id;
      description += '\n\n';
      var event = {
        title: _this.props.meeting.title,
        description: description,
        start: date,
        startInputType: "local",
        startOutputType: "local",
        uid: uid + '@app.haldor.se',
        productId: 'haldor/education',
        duration: {
          hours: hours,
          minutes: minutes
        },
        status: 'CONFIRMED',
        organizer: {
          name: _this.props.currentUser.firstName,
          email: _this.props.currentUser.email
        }
      };
      ics.createEvent(event, function (error, value) {
        window.open("data:text/calendar;charset=utf-8," + encodeURI(value));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderNote", function (reference) {
      var date = new DateTime(reference.created);

      if (!reference["public"] && !_this.state.showPrivateNotes) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "note",
        key: reference.id
      }, reference.title != null ? /*#__PURE__*/React.createElement("h3", null, reference.title) : null, /*#__PURE__*/React.createElement("p", {
        dangerouslySetInnerHTML: {
          __html: reference.text
        }
      }), /*#__PURE__*/React.createElement("p", {
        className: "creator"
      }, reference.author != null ? reference.author.firstName + " " + reference.author.lastName : null, /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 400
        }
      }, " ", date.getFromNow()), /*#__PURE__*/React.createElement("span", {
        className: "bull",
        style: {
          fontWeight: 400
        }
      }, reference["public"] != null && !reference["public"] ? _this.props.translate('private-note') : _this.props.translate('shared-note')), reference.creator == _this.props.user.id || reference.id == _this.props.createdNote ? /*#__PURE__*/React.createElement("span", {
        className: "bull",
        style: {
          fontWeight: 400,
          cursor: 'pointer'
        },
        onClick: function onClick() {
          return _this.onNoteClick(reference);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Pen_Small"
      }), " ", _this.props.translate('Edit')) : null, reference.creator == _this.props.user.id || reference.id == _this.props.createdNote ? /*#__PURE__*/React.createElement("span", {
        className: "bull",
        style: {
          fontWeight: 400,
          cursor: 'pointer'
        },
        onClick: function onClick() {
          return _this.onNoteRemove(reference);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      }), " ", _this.props.translate('Remove')) : null));
    });

    _defineProperty(_assertThisInitialized(_this), "onConversation", function (participant) {
      _this.setState({
        conversationMember: participant
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onConversationClose", function () {
      _this.setState({
        conversationMember: null
      });
    });

    _defineProperty(_assertThisInitialized(_this), "isUpdating", function () {
      _this.setState({
        loading: true
      });

      var promises = [_this.props.getMeetingInstance(_this.props.match.params.id, _this.props.match.params.instanceId), _this.props.getNotesByReference(_this.props.match.params.instanceId, "MEETING_INSTANCE")];
      Promise.all(promises).then(function () {});
    });

    _defineProperty(_assertThisInitialized(_this), "isUpdated", function () {
      _this.setState({
        loading: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "unbookMeeting", function () {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('are-you-sure-unbook-meeting'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('No'),
        confirmButtonText: _this.props.translate('Yes')
      }).then( /*#__PURE__*/function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(result) {
          var instance;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  if (result.value != null) {
                    _this.setState({
                      loading: true
                    });

                    instance = _this.props.meetingInstance;
                    instance.date = null;
                    instance.endDate = null;

                    _this.props.updateMeetingInstanceDate(instance).then(function () {
                      _this.setState({
                        loading: false
                      });
                    });
                  }

                case 1:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9);
        }));

        return function (_x6) {
          return _ref9.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "completeMeeting", function () {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('are-you-sure-complete-meeting'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('No'),
        confirmButtonText: _this.props.translate('Yes')
      }).then( /*#__PURE__*/function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(result) {
          var instance;
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  if (result.value != null) {
                    _this.setState({
                      loading: true
                    });

                    instance = _this.props.meetingInstance;
                    instance.status = "COMPLETED";

                    _this.props.updateMeetingInstance(instance).then(function () {
                      _this.props.history.push('/meeting/' + _this.props.meeting.id);
                    });
                  }

                case 1:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10);
        }));

        return function (_x7) {
          return _ref10.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "openMeeting", function () {
      swal.fire({
        title: _this.props.translate('are-you-sure'),
        text: _this.props.translate('are-you-sure-open-meeting'),
        showCancelButton: true,
        cancelButtonText: _this.props.translate('No'),
        confirmButtonText: _this.props.translate('Yes')
      }).then( /*#__PURE__*/function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(result) {
          var instance;
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  if (result.value != null) {
                    _this.setState({
                      loading: true
                    });

                    instance = _this.props.meetingInstance;
                    instance.status = "ACTIVE";

                    _this.props.updateMeetingInstance(instance).then(function () {
                      _this.setState({
                        loading: false
                      });
                    });
                  }

                case 1:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11);
        }));

        return function (_x8) {
          return _ref11.apply(this, arguments);
        };
      }());
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeStudentLed", function () {
      var instance = _this.props.meetingInstance;
      instance.studentLed = !_this.props.meetingInstance.studentLed;

      _this.props.updateMeetingInstance(instance);
    });

    _defineProperty(_assertThisInitialized(_this), "renderTeamsHtml", function () {
      var strHtml = _this.props.meetingInstance.teamsMeetingData.joinHtml;
      var locale = getActiveLanguage();
      strHtml = strHtml.replace("Learn more about Teams", "");

      if (locale == 'sv-se') {
        strHtml = strHtml.replace("Join Microsoft Teams Meeting", "Anslut till Microsoft Teams-möte");
        strHtml = strHtml.replace("Meeting options", "Mötesalternativ");
        strHtml = strHtml.replace("Learn more about Teams", "Läs mer om Teams");
        strHtml = strHtml.replace("en-US", "sv-SE");
      }

      strHtml = strHtml.replace("width:100%;height: 20px;", "width:100%;height: 1px;");
      strHtml = strHtml.replace("margin-top: 24px;", "margin-top: 5px;");
      strHtml = strHtml.replace("white-space:nowrap;color:gray;opacity:.36;", "");
      strHtml = strHtml.replace("white-space:nowrap;color:gray;opacity:.36;", "");
      strHtml = strHtml.replace("|", "");
      strHtml = strHtml.replace("________________________________________________________________________________", "<hr/>");
      strHtml = strHtml.replace("________________________________________________________________________________", "<hr/>");
      return /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: strHtml
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderTeamsHtmlFromData", function () {
      var isTeacher = isUserTeacher(_this.props.currentUser);
      var isAdmin = isUserAdministrator(_this.props.currentUser);
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        onClick: _this.onJoinTeamsMeeting,
        type: "target"
      }, _this.props.translate('join-teamsmeeting')), (isTeacher || isAdmin) && _this.props.schedule.teamsMeetingData != null ? /*#__PURE__*/React.createElement(Button, {
        onClick: _this.onOptionsTeamsMeeting,
        type: "target"
      }, _this.props.translate('options-teamsmeeting')) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderTeamsSettings", function () {
      var meeting = _this.props.meeting;

      if (meeting.status == 'COMPLETED') {
        return null;
      }

      var isTeacher = isUserTeacher(_this.props.currentUser);
      var isAdmin = isUserAdministrator(_this.props.currentUser);

      if (!_this.props.services.teamsMeeting) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", null, _this.props.meetingInstance.teamsMeeting != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, _this.props.meetingInstance.teamsMeetingData.joinHtml != null ? _this.renderTeamsHtml() : _this.renderTeamsHtmlFromData()) : isTeacher && _this.props.currentUser.id == _this.props.meeting.creator || isAdmin ? /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: _this.createTeamsMeeting,
        type: "secondary",
        style: {
          marginTop: 5
        },
        disabled: _this.state.creatingTeamsMeeting
      }, _this.state.creatingTeamsMeeting ? /*#__PURE__*/React.createElement(Spinner, null) : null, _this.props.translate('create-teamsmeeting'))) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderForm", function (form, index) {
      var user = new User(_this.props.user);

      if (!user.isStudent() || form.participant.userID == user.data.id) {
        var _form$formInstance;

        return /*#__PURE__*/React.createElement("div", {
          key: index,
          onClick: function onClick() {
            return _this.onFormInstanceClick(form);
          },
          className: "form-item"
        }, /*#__PURE__*/React.createElement("div", {
          className: "cell title"
        }, form.form.reference.title), /*#__PURE__*/React.createElement("div", {
          className: "cell"
        }, form.participant.user.firstName, " ", form.participant.user.lastName), /*#__PURE__*/React.createElement("div", {
          className: "cell"
        }, form.formInstance != null ? new DateTime(form.formInstance.reference.edited).getLongDateWithTime() : ''), /*#__PURE__*/React.createElement("div", {
          className: "cell"
        }, ((_form$formInstance = form.formInstance) === null || _form$formInstance === void 0 ? void 0 : _form$formInstance.reference.status) == 'SUBMITTED' ? _this.props.translate('turned-in') : _this.props.translate('not-turned-in')));
      } else {
        return null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "submitFormInstance", function (values) {
      return new Promise(function (resolve) {
        if (values.id == null) {
          values.formID = _this.state.form.id;

          _this.props.createMeetingFormInstance(_this.props.meeting.id, _this.props.meetingInstance.id, values).then(function () {
            resolve(1);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "submitFollowUpForm", function (values) {
      return new Promise(function (resolve) {
        if (values.id == null) {
          _this.props.createMeetingFormInstance(_this.props.meeting.id, _this.props.meetingInstance.id, values).then(function () {
            _this.props.getMeetingInstance(_this.props.meeting.id, _this.props.meetingInstance.id);

            resolve(1);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleBooking", function (instance) {
      _this.setState({
        bookingModal: !_this.state.bookingModal,
        bookingInstance: instance
      });
    });

    moment.locale(getActiveLanguage());
    _this.state = {
      loading: true,
      loadingFormTemplate: false,
      creatingTeamsMeeting: false,
      saving: false,
      outcome: '',
      followUp: false,
      participants: [],
      noteForm: false,
      formInstance: null,
      answerFormModal: false,
      date: moment(),
      modalFormInstance: false,
      editMeetingInstanceModal: false,
      conversationMember: null,
      showPrivateNotes: false,
      instanceJustBeenCreated: false
    };
    return _this;
  }
  /* Helpers */


  _createClass(MeetingInstance, [{
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
    /* Lifecycle methods */

  }, {
    key: "loadInstance",
    value: function loadInstance() {
      var _this$props$meeting,
          _this2 = this;

      var _this$props4 = this.props,
          getMeetingInstance = _this$props4.getMeetingInstance,
          getMeeting = _this$props4.getMeeting,
          getNotesByReference = _this$props4.getNotesByReference,
          match = _this$props4.match;
      var promises = [];
      this.setState({
        loading: true
      });
      promises.push(getMeetingInstance(match.params.id, match.params.instanceId));
      promises.push(getNotesByReference(match.params.instanceId, "MEETING_INSTANCE"));

      if (this.props.meeting == null || ((_this$props$meeting = this.props.meeting) === null || _this$props$meeting === void 0 ? void 0 : _this$props$meeting.id) != match.params.id) {
        promises.push(getMeeting(match.params.id));
      }

      Promise.all(promises).then(function () {
        _this2.props.setPageTitle(_this2.props.meeting.title);

        var outcome = '';

        if (_this2.props.meetingInstance.outcome != null) {
          outcome = _this2.props.meetingInstance.outcome;
        }

        _this2.setState({
          loading: false,
          saving: false,
          outcome: outcome,
          date: _this2.props.meetingInstance.date != null ? moment.utc(_this2.props.meetingInstance.date).local() : null,
          endDate: _this2.props.meetingInstance.endDate != null ? moment.utc(_this2.props.meetingInstance.endDate).local() : null,
          description: _this2.props.meetingInstance.description,
          followUp: _this2.props.meetingInstance.followUp,
          participants: _this2.props.meetingInstance.participants.filter(function (t) {
            return t.present;
          })
        });
      })["catch"](function (er) {
        console.log(er);

        _this2.setState({
          notFound: true
        });
      });
    }
    /* Events */

  }, {
    key: "getMeetingForms",
    value: function getMeetingForms() {
      var _this3 = this;

      // Hämtar alla formulär (exkl. Follow up)
      var forms = this.props.meeting.relationships.filter(function (t) {
        if (t.referenceType == "FORM" && t.targetedAudience != "FOLLOWUP") {
          return true;
        }

        return false;
      }).map(function (t) {
        return t;
      }); // Mappar mot insända formulär

      var user = new User(this.props.user);
      var meetingInstance = this.props.meetingInstance;
      var returnForms = [];

      if (user.isStudent() && !this.props.meetingInstance.studentLed) {
        forms.forEach(function (form) {
          meetingInstance.participants.forEach(function (participant) {
            if (participant.userID == user.data.userId && form.targetedAudience == "STUDENT") {
              var instance = null;
              meetingInstance.relationships.forEach(function (meetingRelationship) {
                if (meetingRelationship.referenceType == 'FORMINSTANCE' && form.referenceID == meetingRelationship.reference.formID && meetingRelationship.reference.assignedTo == user.data.userId) {
                  instance = meetingRelationship;
                }
              });
              returnForms.push({
                form: form,
                participant: participant,
                formInstance: instance
              });
            }
          });
        });
        return returnForms;
      }

      if (user.isStudent() && this.props.meetingInstance.studentLed) {
        forms.forEach(function (form) {
          meetingInstance.participants.forEach(function (participant) {
            if (participant.userType == form.targetedAudience) {
              var formInstance = null;

              _this3.props.meetingInstance.relationships.forEach(function (relationship) {
                if (relationship.referenceType == "FORMINSTANCE" && relationship.reference.formID == form.referenceID && relationship.reference.assignedTo == participant.userID) {
                  formInstance = relationship;
                }
              });

              returnForms.push({
                form: form,
                participant: participant,
                formInstance: formInstance
              });
            }
          });
        });
        return returnForms;
      }

      ;
      forms.forEach(function (form) {
        meetingInstance.participants.forEach(function (participant) {
          if (participant.userType == form.targetedAudience) {
            var formInstance = null;

            _this3.props.meetingInstance.relationships.forEach(function (relationship) {
              if (relationship.referenceType == "FORMINSTANCE" && relationship.reference.formID == form.referenceID && relationship.reference.assignedTo == participant.userID) {
                formInstance = relationship;
              }
            });

            returnForms.push({
              form: form,
              participant: participant,
              formInstance: formInstance
            });
          }
        });
      });
      return returnForms;
    }
  }, {
    key: "getFollowUpForms",
    value: function getFollowUpForms() {
      var _this4 = this;

      var forms = this.props.meeting.relationships.filter(function (t) {
        if (t.referenceType == "FORM" && t.targetedAudience == "FOLLOWUP") {
          return true;
        }

        return false;
      }).map(function (t) {
        return t;
      });
      var user = new User(this.props.user);
      var returnForms = [];

      if (user.isStudent() && !this.props.meetingInstance.studentLed) {
        forms.forEach(function (form) {
          var formInstance = null;

          _this4.props.meetingInstance.relationships.forEach(function (relationship) {
            if (relationship.referenceType == "FORMINSTANCE") {
              if (relationship.reference.formID == form.referenceID && _this4.props.meetingInstance.status == "COMPLETED") {
                formInstance = relationship;
                returnForms.push({
                  form: form,
                  formInstance: formInstance
                });
              }
            }
          });
        });
      } else if (user.isStudent() && this.props.meetingInstance.studentLed) {
        forms.forEach(function (form) {
          var formInstance = null;

          _this4.props.meetingInstance.relationships.forEach(function (relationship) {
            if (relationship.referenceType == "FORMINSTANCE") {
              if (relationship.reference.formID == form.referenceID) {
                formInstance = relationship;
              }
            }
          });

          returnForms.push({
            form: form,
            formInstance: formInstance
          });
        });
      } else if (!user.isStudent()) {
        forms.forEach(function (form) {
          var formInstance = null;

          _this4.props.meetingInstance.relationships.forEach(function (relationship) {
            if (relationship.referenceType == "FORMINSTANCE") {
              if (relationship.reference.formID == form.referenceID) {
                formInstance = relationship;
              }
            }
          });

          returnForms.push({
            form: form,
            formInstance: formInstance
          });
        });
      }

      return returnForms;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state$formInsta,
          _this5 = this,
          _this$state$formInsta2;

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      } else if (this.state.loading && !this.state.notFound) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      } else if (this.state.notFound) {
        return /*#__PURE__*/React.createElement("div", {
          className: "single-task"
        }, /*#__PURE__*/React.createElement("h3", null, this.props.translate('not-found')));
      }

      var user = new User(this.props.user);
      var _this$props5 = this.props,
          meetingInstance = _this$props5.meetingInstance,
          meeting = _this$props5.meeting,
          translate = _this$props5.translate;
      var student = this.props.meetingInstance.student;
      var notes = [];
      meetingInstance.relationships.forEach(function (relationship) {
        if (relationship.referenceType == "NOTE" && relationship.reference != null) {
          relationship.reference["public"] = true;
          return notes.push(relationship.reference);
        }
      });
      this.props.notes.forEach(function (note) {
        if (notes.findIndex(function (t) {
          return t.id == note.id;
        }) == -1) {
          note["public"] = false;
          notes.push(note);
        }
      });
      notes.sort(function (a, b) {
        return new Date(b.created) - new Date(a.created);
      });
      var isPreschool = this.props.currentUser.schools.getActiveSchool(this.props.currentUser.userId).type == PRESCHOOL;
      var forms = this.getMeetingForms();
      var followUpForms = this.getFollowUpForms();
      var hasBooked = meetingInstance.date != null;
      var hasFilledForms = true;
      var nrOfForms = 0;
      var nrOfSubmittedForms = 0;
      var isAuthoritative = this.props.user.authoritative != null && this.props.user.authoritative ? true : false;

      if (forms != null) {
        if (forms.filter(function (form) {
          return form.formInstance == null || form.formInstance != null && form.formInstance.reference.status == "SAVED";
        }).length > 0) {
          hasFilledForms = false;
        }

        nrOfForms = forms.length;
        nrOfSubmittedForms = forms.filter(function (form) {
          return form.formInstance != null && form.formInstance.reference.status == "SUBMITTED";
        }).length;
      }

      var formLocked = this.props.meetingInstance.status == 'COMPLETED' || this.props.meeting.status == 'COMPLETED';
      return /*#__PURE__*/React.createElement("div", {
        className: "single-task meeting single-instance"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.modalFormInstance,
        type: "small",
        overridePrompt: true,
        onClose: this.toggleFormPreview,
        title: translate('answers')
      }, /*#__PURE__*/React.createElement(DisplayFormResults, {
        fields: this.state.formTemplateFields,
        instance: (_this$state$formInsta = this.state.formInstance) === null || _this$state$formInsta === void 0 ? void 0 : _this$state$formInsta.reference
      })), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.noteForm,
        type: "small",
        onClose: function onClose() {
          return _this5.toggleNoteForm();
        },
        title: this.props.activeNote ? translate('edit-meeting-note') : translate('new-meeting-note')
      }, /*#__PURE__*/React.createElement(NoteForm, {
        onAbort: this.toggleNoteForm,
        reference: "MEETING_INSTANCE",
        id: meetingInstance.id,
        shareLabel: this.props.translate('private-meeting-note'),
        references: [{
          referenceID: meetingInstance.id,
          referenceType: 'MEETING_INSTANCE'
        }, {
          referenceID: meetingInstance.studentId,
          referenceType: 'STUDENT'
        }]
      })), /*#__PURE__*/React.createElement(Modal, {
        type: "small",
        isOpen: this.state.bookingModal,
        onClose: function onClose(instance) {
          return _this5.toggleBooking(instance);
        },
        title: this.props.translate('book-meeting-time')
      }, /*#__PURE__*/React.createElement(BookMeeting, {
        onClose: function onClose(instance) {
          _this5.toggleBooking(instance);
        },
        meeting: this.props.meeting,
        instance: this.props.meetingInstance
      })), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.editMeetingInstanceModal,
        type: "small",
        onClose: this.toggleEditMeetingInstanceModal,
        title: translate('invite-participants')
      }, /*#__PURE__*/React.createElement(UpdateMeetingInstance, {
        onSubmit: this.updateMeetingInstance,
        meetingInstance: this.props.meetingInstance
      })), /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.answerFormModal,
        onClose: this.toggleAnswerForm,
        title: translate('forms')
      }, this.state.formTemplate != null ? /*#__PURE__*/React.createElement(FormInstance, {
        form: this.state.formTemplate.id.toString(),
        fields: this.state.formTemplateFields,
        instance: (_this$state$formInsta2 = this.state.formInstance) === null || _this$state$formInsta2 === void 0 ? void 0 : _this$state$formInsta2.reference,
        onAbort: this.toggleAnswerForm,
        onSubmit: this.submitFormInstance,
        user: user,
        followUp: false,
        disabled: meeting.status == 'COMPLETED'
      }) : /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), this.props.services.conversations ? /*#__PURE__*/React.createElement(Message, {
        activeUser: this.state.conversationMember,
        meetingInstance: meetingInstance,
        onClose: this.onConversationClose,
        studentId: this.props.meetingInstance.studentId
      }) : null, /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side",
        style: {
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Tab, {
        title: translate('meeting-instance'),
        route: "info"
      }, user.isStudent() && (!hasBooked || !hasFilledForms) && meeting.status == 'ACTIVE' && meetingInstance.status != 'COMPLETED' ? /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('To do')), /*#__PURE__*/React.createElement("div", null, !hasBooked && isAuthoritative ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          return _this5.toggleBooking(meetingInstance);
        },
        style: {
          display: 'inline-block',
          marginBottom: '.35rem',
          cursor: 'pointer'
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: false,
        label: translate('book-meeting-time'),
        disabled: true
      }))) : null, !hasFilledForms ? /*#__PURE__*/React.createElement("a", {
        href: "#forms",
        style: {
          marginBottom: '.35rem',
          cursor: 'pointer',
          color: '#3a3a3a',
          textDecoration: 'none'
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: false,
        label: translate('fill-form'),
        disabled: true
      })) : null)) : null, /*#__PURE__*/React.createElement(Block, null, meeting.status == 'COMPLETED' ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '.55rem'
        },
        className: "color--meta size-14"
      }, translate('meeting-closed')) : null, meetingInstance.studentLed ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '.55rem'
        },
        className: "color--meta size-14"
      }, translate('studentled-meeting')) : null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('Information-to-participants')), /*#__PURE__*/React.createElement("div", {
        className: "size-14"
      }, /*#__PURE__*/React.createElement(PostContent, null, meeting.description), /*#__PURE__*/React.createElement(PostContent, null, meetingInstance.description)), !user.isStudent() && meeting.creator == user.data.id && !isPreschool ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('studentled')), /*#__PURE__*/React.createElement(Checkbox, {
        value: meetingInstance.studentLed,
        disabled: this.props.meeting.status == "COMPLETED",
        label: translate('studentled-meeting'),
        onChange: function onChange() {
          _this5.onChangeStudentLed();
        }
      })) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, user.isStudent() || meeting.creator != user.data.id ? translate('participants') : translate('attending')), /*#__PURE__*/React.createElement(MeetingUsers, {
        meetingInstance: meetingInstance,
        users: meetingInstance.participants,
        onConversation: this.onConversation,
        onParticipantSelect: this.onParticipantSelect,
        onParticipantRemove: this.onRemoveParticipant,
        isStudent: user.isStudent() || meeting.creator != user.data.id
      }), (meeting.status == 'ACTIVE' || meeting.status == 'DRAFT') && !user.isStudent() && user.data.id == meeting.creator ? /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginTop: '.5rem'
        },
        onClick: this.toggleEditMeetingInstanceModal
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), " ", this.props.translate('invite-participants')) : null), meetingInstance.date != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('time')), new DateTime(meetingInstance.date).getLongDate(), ' • ', new DateTime(meetingInstance.date).getTime(), meetingInstance.endDate != null ? ' - ' + new DateTime(meetingInstance.endDate).getTime() : null) : null)), forms.length > 0 ? /*#__PURE__*/React.createElement(Tab, {
        title: user.isStudent() ? translate('forms') : /*#__PURE__*/React.createElement("span", null, translate('forms'), " ", /*#__PURE__*/React.createElement("div", {
          style: {
            marginLeft: "0.5rem"
          },
          className: "new-badge"
        }, /*#__PURE__*/React.createElement("span", null, nrOfSubmittedForms.toString(), " / ", nrOfForms.toString()), " "), " "),
        route: "forms"
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('forms')), /*#__PURE__*/React.createElement("div", {
        className: "meeting-forms"
      }, forms.map(this.renderForm)))) : null, this.props.services.notes ? /*#__PURE__*/React.createElement(Tab, {
        title: translate('meeting-notes'),
        route: "meeting-notes"
      }, /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("div", {
        className: "notes"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('meeting-notes')), !user.isStudent() ? /*#__PURE__*/React.createElement(Checkbox, {
        value: this.state.showPrivateNotes,
        label: translate('show-private-notes'),
        onChange: function onChange(value) {
          return _this5.setState({
            showPrivateNotes: value
          });
        }
      }) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.55rem'
        }
      }), notes.map(function (note) {
        return _this5.renderNote(note);
      }), notes.length == 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1.25rem'
        }
      }, this.props.translate('no-notes')) : null, !user.isStudent() ? /*#__PURE__*/React.createElement(Button, {
        disabled: meeting.status == 'COMPLETED',
        "data-tooltip": meeting.status == 'COMPLETED' ? translate('meeting-is-locked-notes') : null,
        type: "secondary",
        onClick: function onClick() {
          return _this5.toggleNoteForm();
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), translate('new-meeting-note')) : null))) : null)), /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side",
        style: {
          paddingTop: 0
        }
      }, !user.isStudent() && meeting.creator == user.data.id ? /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, this.props.translate('tools')), /*#__PURE__*/React.createElement("div", null, this.props.meetingInstance.status != "COMPLETED" && this.props.meeting.status != 'COMPLETED' ? /*#__PURE__*/React.createElement(Button, {
        onClick: this.completeMeeting
      }, this.props.translate('close-meeting')) : this.props.meeting.status != 'COMPLETED' ? /*#__PURE__*/React.createElement(Button, {
        onClick: this.openMeeting,
        type: "secondary"
      }, this.props.translate('open-meeting-again')) : /*#__PURE__*/React.createElement("div", {
        className: "color--meta",
        style: {
          marginBottom: '.75rem'
        }
      }, this.props.translate('Meeting is archived. Unlock meeting to make changes.'))), /*#__PURE__*/React.createElement("div", null, this.props.meetingInstance.status != 'COMPLETED' && this.props.meeting.status != 'COMPLETED' ? /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.onDeleteMeetingInstance,
        style: {
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      }), " ", this.props.translate('Delete')) : null), this.props.meeting.status != 'COMPLETED' && this.props.meetingInstance.date != null && this.props.meetingInstance.endDate != null ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.unbookMeeting,
        type: "secondary",
        style: {
          marginTop: 5
        }
      }, this.props.translate('unbook'))) : this.props.meetingInstance.teamsMeeting != null ? // <div>
      // 	<Button onClick={this.unbookMeeting} type="secondary" style={{ marginTop: 5 }}>
      // 		{this.props.translate('unbook-teams-meeting')}
      // 	</Button>
      // </div>
      null : null, this.props.meetingInstance.date != null && this.props.meetingInstance.endDate != null ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.generateICS,
        type: "secondary",
        style: {
          marginTop: 5
        }
      }, this.props.translate('calendar-file'))) : null, this.renderTeamsSettings()) : /*#__PURE__*/React.createElement("div", {
        className: "action-section"
      }, /*#__PURE__*/React.createElement("h3", null, this.props.translate('tools')), this.renderTeamsSettings()), user.isStudent() && isAuthoritative && meetingInstance.status != 'COMPLETED' && meeting.status == 'ACTIVE' ? /*#__PURE__*/React.createElement("div", {
        className: "single-actions",
        style: {
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick() {
          _this5.toggleBooking(_this5.props.meetingInstance);
        }
      }, this.props.translate('book-meeting-time'))), this.props.meetingInstance.date != null && this.props.meetingInstance.endDate != null ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        onClick: this.unbookMeeting,
        type: "secondary",
        style: {
          marginTop: 5
        }
      }, this.props.translate('unbook'))) : null) : null), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), followUpForms.length > 0 ? /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, translate('follow-up')), /*#__PURE__*/React.createElement("div", {
        className: "df aic save-error-notice"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ico"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Alert_Red"
      })), /*#__PURE__*/React.createElement("div", null, translate('If the form was opened by several people at the same time, there is a risk that information may be overwritten by mistake.'), getActiveLanguage() == 'sv-se' ? /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: translate('<a href="%LINK%" target="_blank">Read more in the Knowledge Bank</a>')
        }
      }) : null)), followUpForms.map(function (form, i) {
        var _form$formInstance2;

        return /*#__PURE__*/React.createElement("div", {
          key: i
        }, /*#__PURE__*/React.createElement("span", {
          className: "title"
        }, form.form.reference.title), /*#__PURE__*/React.createElement(FormInstance, {
          form: form.form.referenceID,
          fields: form.form.reference.formTemplate.fields,
          formTemplate: form.form.reference.formTemplate,
          instance: (_form$formInstance2 = form.formInstance) === null || _form$formInstance2 === void 0 ? void 0 : _form$formInstance2.reference,
          user: user,
          instanceJustBeenCreated: _this5.state.instanceJustBeenCreated,
          onSubmit: _this5.submitFollowUpForm,
          references: forms,
          followUp: true,
          studentLed: _this5.props.meetingInstance.studentLed,
          locked: formLocked,
          shrinkFields: true
        }));
      })) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '3rem'
        }
      }), /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('student-card')), /*#__PURE__*/React.createElement(UserProgress, {
        userId: student.id,
        isupdated: this.isUpdated,
        isupdating: this.isUpdating
      })));
    }
  }]);

  return MeetingInstance;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    meeting: state.Meetings.meeting,
    meetingInstance: state.Meetings.meetingInstance,
    notes: state.Notes.notes,
    createdNote: state.Notes["new"],
    formTemplate: state.Templates.formTemplate,
    instance: state.Templates.instance,
    user: state.user.currentUser,
    languages: state.Languages.languages,
    services: state.Services.availableServices,
    currentUser: state.user.currentUser,
    activeNote: state.Notes.active
  };
}

export default withRouter(connect(mapStateToProps, {
  getMeetingInstance: getMeetingInstance,
  createMeetingInstanceRelationship: createMeetingInstanceRelationship,
  setPageTitle: setPageTitle,
  getMeeting: getMeeting,
  updateMeetingInstance: updateMeetingInstance,
  getNotesByReference: getNotesByReference,
  getFormTemplate: getFormTemplate,
  setActiveNote: setActiveNote,
  resetActiveNote: resetActiveNote,
  deleteMeetingInstanceRelationship: deleteMeetingInstanceRelationship,
  getForm: getForm,
  getFormInstance: getFormInstance,
  updateFormInstance: updateFormInstance,
  setPageActions: setPageActions,
  removeNote: removeNote,
  updateMeetingInstanceDate: updateMeetingInstanceDate,
  createMeetingFormInstance: createMeetingFormInstance,
  addError: addError,
  deleteMeetingInstanceParticipant: deleteMeetingInstanceParticipant,
  deleteMeetingInstance: deleteMeetingInstance
})(MeetingInstance));